import { applyMixins, isValidUUID } from '@appbolaget/helpers';

import { Model } from './Model';
import { Helpers } from '../helpers';
import { MetaInterface } from '../helpers/interfaces';

export class Location extends Model implements MetaInterface {
    model = 'Location';
    module = 'cms';
    endpoint = 'locations';

    fields: any = [
        'id',
        'uuid',
        'title',
        'slug',
        'global',
        'meta',
        'polygon',
        'latitude',
        'longitude',
        'children',
        'parent',
        'parent_id',
        'type',
        'viewport',
    ];

    id?: number;
    uuid?: string;
    title?: string;
    slug?: string;
    global?: boolean;
    children?: Location[];
    latitude?: number;
    longitude?: number;
    polygon?: string;
    hasChildren = true;
    isCollapsed?: boolean;
    parent?: Location;
    parentArray?: Location[];
    parent_id?: number;
    treeDisplay?: string;
    type?: string;
    viewport: { ne: { lat: number; lng: number }; sw: { lat: number; lng: number } };

    autocompleteLabel?: string;
    searchableFields: any = ['title.value'];
    excludeFromHttp = ['hasChildren', 'id', 'uuid', 'treeDisplay'];

    constructor(data?: any) {
        super();

        this.initialize(data);

        if (data) {
            if (data.latitude && data.longitude) {
                this.latitude = parseFloat(data.latitude);
                this.longitude = parseFloat(data.longitude);
            }

            if (data.parent) {
                data.parent = new Location(data.parent);
                this.parentArray = Helpers.getParentArray(data).reverse();
            }

            if (data.viewport && typeof data.viewport === 'string') {
                this.viewport = JSON.parse(data.viewport);
            }

            this.treeDisplay = `${data.title}`;
        }
    }

    isRealLocation(): boolean {
        return isValidUUID(this.uuid);
    }
}

applyMixins(Location, [MetaInterface]);
